import { supabase } from '../supabaseClient';

export const getActiveRestaurantSession = async () => {
  const { data, error } = await supabase.rpc('get_active_restaurant_session');
  if (error) return { data: null, error };
  return { data: Array.isArray(data) ? data[0] || null : data, error: null };
};

export const setActiveRestaurantSession = async (restaurantId) => {
  const { data, error } = await supabase.rpc('set_active_restaurant_session', {
    p_restaurant_id: restaurantId,
    p_device_label: `${navigator.platform || 'device'} admin`,
    p_user_agent: navigator.userAgent || '',
  });

  if (error) return { data: null, error };
  return { data: Array.isArray(data) ? data[0] || null : data, error: null };
};
